module.exports = __webpack_public_path__ + "media/images/number_16-3c5cbe7549e0d5903937d3f95def7d3a.png";